<template>
  <rpm-table :columns="columns" :data="collaborations.collaborations" title="Colaborações">
    <template #functions>
      <section class="flex flex-row-reverse w-full">
        <rpm-button
            class="w-6 h-6 rounded"
            font-size="text-sm"
            icon="fa-solid fa-plus"
            @click="openModal({})"
        ></rpm-button>
      </section>
    </template>
    <template #actions="{ item }">
      <rpm-button
          icon="fa-solid fa-pen-to-square"
          color="transparent"
          tooltip-text="editar"
          @click="openModal(item)"
      ></rpm-button>
      <rpm-button
          icon="fa-regular fa-trash-can"
          color="transparent"
          tooltip-text="remover"
          @click="openRemoveModal(item)"
      ></rpm-button>
    </template>
  </rpm-table>

  <rpm-modal
      header="Atualizar colaboração"
      class="flex flex-col gap-10"
      persist
      :open="modalOpen"
      @close="modalOpen = false"
  >

    <section class="grid grid-cols-2 gap-y-8 gap-x-6">
      <rpm-input
          v-model="form.organization_id"
          label="Organização"
          required
          type="select"
          :options="organizations"
          :errors="errors.organization_id"
          optionValue="id"
          optionLabel="name"
          class="col-span-2"
      ></rpm-input>
      <rpm-input
          v-model="form.collaborator_function_id"
          label="Função"
          required
          type="select"
          :options="collaboratorFunctions"
          :errors="errors.collaborator_function_id"
          optionValue="id"
          optionLabel="name"
      ></rpm-input>
      <rpm-input
          v-model="form.start_date"
          label="Data de início"
          type="date"
          required
          :errors="errors.start_date"
      ></rpm-input>
      <rpm-input
          v-model="form.end_date"
          label="Data final"
          type="date"
      ></rpm-input>
      <rpm-input
          v-model="form.registration_id"
          label="Matrícula"
          type="text"
          required
          :errors="errors.registration_id"
      ></rpm-input>

    </section>

    <section class="flex flex-row justify-center gap-6">
      <rpm-button
          color="gray"
          label="Cancelar"
          @click="modalOpen = false"
      ></rpm-button>

      <rpm-button
          label="Confirmar"
          @click="save"
          :loading="loading"
      ></rpm-button>
    </section>

  </rpm-modal>

  <rpm-modal
      header="Remover colaboração"
      class="flex flex-col gap-10"
      persist
      :open="modalRemoveOpen"
  >
    Remover colaboração em {{ selectedCollaboration.organization }}?

    <section class="flex flex-row justify-center gap-6">
      <rpm-button @click="removeCollaboration" label="Salvar"/>
      <rpm-button @click="modalRemoveOpen = false" label="Fechar" color="gray"/>
    </section>
  </rpm-modal>
</template>

<script>

import {useRoute} from "vue-router";
import {getErrors} from "#functions/validator.js"
import {ref, onMounted, watch} from "vue";
import collaboratorRepository from '#repositories/collaboratorRepository.js'
import organizationsRepository from '#repositories/organizationsRepository.js'
import collaboratorFunctionRepository from '#repositories/collaboratorFunctionRepository.js'
import RpmTable from "#components/RpmTable.vue";
import RpmModal from "#components/RpmModal.vue";
import moment from 'moment'

export default {
  name: 'Functions',
  components: {
    RpmTable,
    RpmModal
  },
  methods: {
    updateCollaborator() {
      this.loading = true
      this.form.collaborator_organization_id = this.form.id
      collaboratorRepository.updateCollaborator(this.collaborations.id, this.form).then((response) => {
        this.modalOpen = false
        this.fetchCollaborations()
        this.$notify('Adicionado com sucesso', 'success')
      }).catch((response) => {
        getErrors(this.errors, response.errors);
      }).finally(() => {
        this.loading = false
      })
    },
    save() {
      if (this.form.id) {
        this.updateCollaborator()
      } else {
        this.form.person_id = this.collaborations.personid
        collaboratorRepository.addCollaboration(this.form).then((response) => {
          this.modalOpen = false
          this.fetchCollaborations()
          this.$notify('Adicionado com sucesso', 'success')
        }).catch((response) => {
          getErrors(this.errors, response.errors);
        }).finally(() => {
          this.loading = false
        })
      }
    },
    fetchCollaborations() {
      collaboratorRepository.getCollaborator(this.$route.params.id).then((response) => {
        this.selectedCollaborator.id = response.data.id
        this.collaborations = response.data
      })
    },
    fetchOrganizations() {
      organizationsRepository.getOrganizations().then((response) => {
        this.organizations = response.data
      })
    },
    fetchCollaboratorFunctions() {
      collaboratorFunctionRepository.getCollaboratorFunctions().then((response) => {
        this.collaboratorFunctions = response.data
      })
    },
    removeCollaboration() {
      collaboratorRepository.removeCollaboration(this.selectedCollaborator.id, {
        organization_id: this.selectedCollaboration.organization_id
      }).then((response) => {
        this.modalRemoveOpen = false
        this.fetchCollaborations()
        this.$notify(response.message, response.severity)
      })
    }
  },
  mounted() {
    this.fetchCollaborations()
    this.fetchOrganizations()
    this.fetchCollaboratorFunctions()
  },
  setup() {
    const collaborations = ref([])
    const organizations = ref([])
    const collaboratorFunctions = ref([])
    const loading = ref(false)
    const modalRemoveOpen = ref(false)
    const selectedCollaboration = ref({})
    const selectedCollaborator = ref({})
    const errors = ref({})

    const columns = [
      {
        label: '#',
        field: 'id'
      },
      {
        label: 'Data de início',
        field: 'format_start_date'
      },
      {
        label: 'Data final',
        field: 'format_end_date'
      },
      {
        label: 'Organização',
        field: 'organization'
      },
      {
        label: 'Função',
        field: 'function'
      },
      {
        label: 'Principal',
        field: 'is_default'
      },
    ]
    const modalOpen = ref(false)
    const form = ref({})


    function formatDate() {
      return moment(value).format('MM/DD/YYY')
    }

    function openModal(item) {
      modalOpen.value = true
      form.value = item
      if (form.value.id) {
        form.value.current_organization = form.value.organization_id
      }
    }

    function openRemoveModal(item) {
      modalRemoveOpen.value = true
      selectedCollaboration.value = item
    }

    return {
      collaborations,
      columns,
      modalOpen,
      form,
      loading,
      organizations,
      collaboratorFunctions,
      modalRemoveOpen,
      selectedCollaboration,
      selectedCollaborator,
      errors,
      openRemoveModal,
      openModal
    }
  }
}
</script>

<style lang="scss" scoped>

</style>e